import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Paper, Typography, Tooltip, Avatar } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import './WorkflowSelector.css';

const WorkflowSelector = ({ activeMode, setActiveMode }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const isGuest = user?.is_guest;

    const handleCardClick = (mode) => {
        if (mode === 'manual') {
            setActiveMode('manual');
        } else if (mode === 'bulk' && !isGuest) {
            // Navigate to the bulk analysis page
            navigate('/app/bulk-analysis');
        }
    };

    return (
        <div className="workflow-selector-container">
            <Paper
                elevation={2}
                className={`workflow-card ${activeMode === 'manual' ? 'active' : ''}`}
                onClick={() => handleCardClick('manual')}
            >
                <div className="workflow-card-header">
                    <Avatar className="workflow-card-icon">
                        <FileUploadIcon />
                    </Avatar>
                    <Typography variant="h6" component="h3">
                        {t('workflowSelector.manualTitle')}
                    </Typography>
                </div>
                <Typography variant="body2">
                    {t('workflowSelector.manualDescription')}
                </Typography>
            </Paper>

            <Tooltip
                title={isGuest ? t('workflowSelector.bulkDisabledTooltip') : ''}
                arrow
                placement="top"
                PopperProps={{ className: 'global-dark-tooltip' }}
            >
                {/* The div is necessary for the tooltip to work on a disabled element */}
                <div>
                    <Paper
                        elevation={2}
                        className={`workflow-card ${isGuest ? 'disabled' : ''}`}
                        onClick={() => handleCardClick('bulk')}
                        // Prevent click events if disabled
                        style={{ pointerEvents: isGuest ? 'none' : 'auto' }}
                    >
                        <div className="workflow-card-header">
                            <Avatar className="workflow-card-icon">
                                <BackupTableIcon />
                            </Avatar>
                            <Typography variant="h6" component="h3">
                                {t('workflowSelector.bulkTitle')}
                            </Typography>
                        </div>
                        <Typography variant="body2">
                            {t('workflowSelector.bulkDescription')}
                        </Typography>
                    </Paper>
                </div>
            </Tooltip>
        </div>
    );
};

export default WorkflowSelector;